import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { BsUpcScan } from "react-icons/bs";
import BarcodeScanner from "../../../../Components/BarcodeScanner/BarcodeScanner";
import { useTranslation } from "react-i18next";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "var(--color-ui-surface)",
  boxShadow: 24,
  p: 4,
};

export default function BarcodeModal({ open, setOpen, setHighlightedRow }) {
  const { t } = useTranslation("inventory");
  const handleClose = () => setOpen(false);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div id="modal-modal-title" style={{ display: "flex" }}>
          <b> {t("stockReceived.scanBarcode")}</b>
          <BsUpcScan style={{ padding: "2px", marginLeft: "2px" }} />
        </div>
        <div id="modal-modal-description" sx={{ mt: 2 }}>
          <BarcodeScanner
            setData={setHighlightedRow}
            handleClose={handleClose}
          />
        </div>
      </Box>
    </Modal>
  );
}
